import RouteApp from "./routes/RouteApp";

function App() {
  return (
    <RouteApp />
  );
}

export default App;
